import React from "react";
import { Link } from "react-router-dom";
import { Navbar } from "../components/Navbar";
import { Footer } from "../components/Footer";
import { ArrowLeft } from "lucide-react";

export const COMPANY = {
  name: "STAND LF",
  legalName: "STAND LF", // [Preencher: denominação social completa / Lda / Unipessoal]
  nif: "510741312",
  address: "Rua Cimo de Vila, 1536, 3880-743 São João de Ovar",
  email: "liderfavorito@gmail.com",
  phone: "924 020 938",
};

const LegalLayout = ({ title, subtitle, children }) => (
  <div className="App">
    <Navbar />
    <main className="max-w-3xl mx-auto px-5 sm:px-8 pt-[112px] pb-24">
      <Link to="/" className="inline-flex items-center gap-2 text-sm font-semibold text-muted-foreground hover:text-foreground transition-colors mb-8">
        <ArrowLeft className="w-4 h-4" /> Voltar
      </Link>
      <span className="block text-primary font-bold text-xs tracking-[0.3em] uppercase">{subtitle}</span>
      <h1 className="font-heading font-black text-4xl sm:text-5xl tracking-tighter mt-3 mb-10">{title}</h1>
      <div className="space-y-8 text-muted-foreground leading-relaxed">{children}</div>
    </main>
    <Footer />
  </div>
);

const Section = ({ n, title, children }) => (
  <section>
    <h2 className="font-heading font-bold text-xl text-foreground tracking-tight mb-3">{n}. {title}</h2>
    <div className="space-y-3">{children}</div>
  </section>
);

export default LegalLayout;
export { Section };
